module.exports = __webpack_public_path__ + "img/sapphire@2x.44b2299.webp";